const HomeLogo = (): JSX.Element => {
  return (
    <div className="home-logo home-logo--blur-in">
      <div className="home-logo__letter-c-outline">
        <div className="home-logo__letter-c-inline"></div>
      </div>
      <div className="home-logo__letter-g-outline">
        <div className="home-logo__letter-g-inline">
          <div className="home-logo__letter-g-box">
            <div className="home-logo__letter-g-box2"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeLogo;
